<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="stats"
      y-value-prefix="stats."
      x-value="date"
      :chart-value-keys="chartValueKeys"
      :yaxis="yAxisConfig"
      :fill="fillConfig"
      :colors="['#FF7300']"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.team_general_muscle_soreness') }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.team_general_muscle_soreness') }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <chart-list-view-table
        :headers="tableHeaders"
        :items="stats"
      >
        <template v-slot:item.date="{ item }">
          {{ formatDate(item.date) }}
        </template>
      </chart-list-view-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import dayjs from 'dayjs'
import ChartListViewTable from '@/components/charts/implementation/ChartListViewTable.vue'

export default {
  name: 'TeamGeneralMuscleSorenessTrendChart',
  components: { ChartListViewTable, LineChart, VisualListToggle },
  props: {
    stats: {
      type: Array,
      required: true,
      default: () => []
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      return [
        {
          key: 'GMS',
          label: this.$t('variables.GMS.long'),
          type: 'area'
        }
      ]
    },
    yAxisConfig() {
      return [
        {
          min: 0,
          max: 5,
          title: { text: this.$t('variables.GMS.long') },
          seriesName: 'GMS'
        }
      ]
    },
    fillConfig() {
      return {
        type: ['gradient'],
        opacity: [1],
        gradient: {
          inverseColors: false,
          shade: 'light',
          type: 'vertical',
          opacityFrom: 0.55,
          opacityTo: 0.25
        }
      }
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.date'),
          value: 'date',
          sortable: true,
          width: '20%'
        },
        {
          text: this.$t('variables.GMS.long'),
          value: 'stats.GMS',
          sortable: true,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('ll')
    }
  }
}
</script>
